import { Box, Typography, Link, IconButton } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useAppContext } from "../../context/AppContext";
import { Pointer } from "lucide-react";

const Footer = () => {
    const { customer, loadingCustomer } = useAppContext();

    if (loadingCustomer) return null;

    const currentYear = new Date().getFullYear();

    // ===== FROM BACKEND =====
    const logoSrc = customer?.logoPath;

    const organizationName =
        customer?.businessName ||
        customer?.displayName ||
        "Agriculture Tech";

    const phone =
        customer?.customer?.contactDetails?.[0]?.phoneNumber || "";

    const email =
        customer?.customer?.contactDetails?.[0]?.email || "";



    // ===== ADDRESS =====
    const address = customer?.customer?.billingAddress;

    // ===== ADDRESS FORMAT =====
    const addressText = address
        ? `${address.addressLine1 || ""},
${address.addressLine2 || ""} ${address.city || ""}, ${address.stateOrProvince || ""} - ${address.postalCode || ""}
India`
        : "";

    // ===== DYNAMIC MAP =====
    const mapUrl =
        customer?.subdomain?.googleMapLocationPath ||
        `https://www.google.com/maps?q=${organizationName}+${address?.city}&output=embed`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}`;

    return (
        <Box>
            <Box
                sx={{
                    backgroundColor: "#FCF6F5",
                    color: "#2BAE66",
                    py: 4,
                    px: 8,
                }}
            >
                {/* MAIN ROW */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        gap: 4,
                    }}
                >
                    {/* ===== LEFT SECTION ===== */}
                    <Box sx={{ flex: 1 }}>
                        <Box
                            component="img"
                            src={logoSrc}
                            alt="organizationName"
                            sx={{
                                height: 60,
                                width: 60,
                                mb: 2,
                                borderRadius: "50%",
                                objectFit: "cover",
                            }}
                        />

                        <Typography
                            sx={{
                                fontWeight: "bold",
                                fontSize: "0.9rem",
                                lineHeight: 1.6,
                            }}
                        >
                            {organizationName} is a leading agricultural institute dedicated to
                            education, research, and sustainable farming innovation.
                        </Typography>
                    </Box>

                    {/* ===== MIDDLE SECTION ===== */}
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                fontWeight: "bold",
                                color: "black",
                                mb: "4px",
                            }}
                        >
                            CONTACT US
                        </Typography>

                        {/* Email */}
                        {email && (
                            <Typography
                                component="a"
                                href={`mailto:${email}`}
                                sx={{
                                    color: "#2BAE66",
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                    lineHeight: 1.4,
                                    mb: "4px",
                                    textDecoration: "none",
                                }}
                            >
                                {email}
                            </Typography>
                        )}

                        {/* =====ADDRESS ===== */}
                        <Typography
                            sx={{
                                fontWeight: "bold",
                                fontSize: "0.9rem",
                                lineHeight: 2,
                                color: "#2BAE66",
                                whiteSpace: "pre-line",
                                mb: "4px",
                            }}
                        >
                            {addressText}
                        </Typography>

                        {/* WHATSAPP */}
                        {phone && (
                            <IconButton
                                href={`https://api.whatsapp.com/send?phone=${phone}`}
                                target="_blank"
                                sx={{ color: "#30c446", p: 0, mt: "2px" }}
                            >
                                <WhatsAppIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                        )}

                    </Box>

                    {/* ===== MAP ===== */}
                    <Box
                        sx={{
                            flex: 1,
                            marginTop: 1.5,
                            maxWidth: 300,
                            height: 200,
                            borderRadius: "5px",
                            overflow: "hidden",
                        }}
                    >
                        <iframe
                            title="map"
                            src={mapUrl}
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "0",
                            }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </Box>
                </Box>
            </Box>

            {/* ===== BOTTOM BAR ===== */}
            <Box
                sx={{
                    backgroundColor: "#FCF6F5",
                    color: "#FFFBEF",
                    p: 2,
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    textAlign: { xs: "center", md: "left" },
                    fontSize: 13,
                    py: 4,
                    px: 8,
                }}
            >
                <Typography
                    sx={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: "0.9rem",
                    }}
                >
                    COPYRIGHT © {currentYear} {organizationName}
                </Typography>

                <Link
                    href="https://www.belageri.com"
                    target="_blank"
                    sx={{
                        fontWeight: "bold",
                        color: "black",
                        textDecoration: "none",
                        fontSize: "0.9rem",
                        cursor: "pointer",
                    }}>
                    DEVELOPED BY{" "}
                    <span style={{ color: "#1976d2" }}>
                        BELAGERI TECHNOLOGIES
                    </span>
                </Link>
            </Box>
        </Box>
    );
};
export default Footer;
